import styled from 'styled-components';

export const InputAndSearchSection = styled.div`
  padding: 40px 0 40px 0;
  width: 100%;
  display: grid;
  grid-template-columns: repeat(3, 1fr) 100px;
  grid-gap: 10px;

  @media (max-width: 1024px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 736px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export const DateLabel = styled.label`
  width: 120px;
`;

export const InputSection = styled.div`
  display: flex;
  align-items: baseline;
`;
